import { suffixOptions, suffixOptionsValues } from '../constants';

export const getApplicantData = (object, key, subKey) => {
  if (!object || !key) {
    if (subKey === 'Suffix') {
      return {
        label: 'None',
        value: 'None',
      };
    }
    return '';
  }

  const ownerData = object[key];

  if (key === 'EIN') {
    if (ownerData === null) {
      return null;
    }

    if (ownerData === '') {
      return '';
    }
  }

  if (!ownerData) {
    return '';
  }

  if (!subKey) {
    return ownerData;
  }

  if (subKey === 'Suffix') {
    if (!suffixOptions[ownerData.Suffix]) {
      return {
        label: 'None',
        value: 'None',
      };
    }

    return {
      label: suffixOptionsValues[ownerData.Suffix],
      value: suffixOptionsValues[ownerData.Suffix],
    };
  }

  return ownerData[subKey];
};

export const getApplicantDataBirthday = (object, key) => {
  const dateOfBirth = getApplicantData(object, key, 'DateOfBirth');

  if (!dateOfBirth) {
    return {};
  }

  const date = new Date(dateOfBirth);

  const [month, day, year] = [
    date.getMonth() + 1,
    date.getDate(),
    date.getFullYear(),
  ];

  return {
    Month: month || null,
    Day: day || null,
    Year: year || null,
  };
};

export const getApplicantDataAddress = (object, key, subKey) => {
  if (!object || !key || !subKey) {
    return '';
  }

  const ownerAddress = object[key];

  if (!ownerAddress) {
    return '';
  }

  return ownerAddress[subKey];
};

export const getApplicantDataPhone = (object, key) => {
  if (!object || !key) {
    return '';
  }

  const phone = getApplicantData(object, key, 'Phone');
  if (!phone) {
    return '';
  }

  return phone;
};
